module.exports = __webpack_public_path__ + "img/spinner.41a3fc3.svg?v=1791296779994";